export class KeyStorage {
  static readonly keyLocalToken = 'access_token';
  static readonly refreshToken = 'refresh_token';
  static readonly keyTheme = 'theme';
  // static readonly activeParentEmail = 'active_parent_email';
}
